<template>
  <div>
    <div>
      <h3>Change Password</h3>
    </div>
  </div>
  <div>
    <div>
      <div>New Password:</div>
      <input type="password" class="password-input" :value="this.newPassword"
        @blur="this.newPassword = $event.target.value" />
    </div>
  </div>
  <div>
    <div class="pass-redeem-confirm">
      <div>Confirm Password:</div>
      <input type="password" class="password-input" :value="this.confirmPassword"
        @blur="this.confirmPassword = $event.target.value" />
    </div>
    <div>
      <button @click="this.changePassword" variant="outlined" style="width: 100px; margin-top: 37px"
        class="settingsBtn">Save</button>
    </div>
  </div>
</template>
<script>
import { useIdentityStore } from '../../store/IdentityStore';
import { mapStores } from 'pinia';
export default {
  data: () => ({
    newPassword: '',
    confirmPassword: '',
    redeemToken: '',
  }),
  computed: {
    ...mapStores(useIdentityStore),
  },
  methods: {
    redeemMC () {
      this.appStore.isRedeeming = true;
      this.mcStore.redeemMC(this.redeemToken);
    },
    handleInput () {
      this.mcStore.isInvalidToken = false;
      this.appStore.isCompleted = false;
    },
    changePassword () {
      if (this.newPassword == '' || this.confirmPassword == '') { return; }
      if (this.newPassword != this.confirmPassword) { return; }
      this.identityStore.setUserPassword(this.newPassword);
    },
  }
};
</script>
<style scoped>
.password-input {
  width: 97%;
  min-height: 35px;
  margin-top: 8px;
  border-radius: 20px;
  padding-left: 10px;
  font-size: .8em;
  border: 1px solid lightgray;
}
.settingsBtn {
  padding: 5px;
  cursor: pointer;
  border: none;
  margin-bottom: 15px;
  margin-right: 15px;
  background-color: var(--nelson-green);
  color: white;
}
.pass-redeem-confirm {
  padding-top: 1rem;
}

</style>